import { Box, Typography } from "@mui/material";
import React from "react";
import { useRecoilState } from "recoil";
import { authState } from "src/store/auth";
import FirstBranchPopup from "./first-branch-popup";
import { useTranslation } from "react-i18next";

const NoAccessPage: React.FC = () => {
  const [auth] = useRecoilState(authState);
  const { user, permissions } = auth;
  const { t } = useTranslation("general");

  const newAccount = permissions.length === 0 && user?.type === "owner";

  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      minHeight={"400px"}
    >
      <Typography>{t("youHaveNoAccessToPage")}</Typography>
      <FirstBranchPopup open={newAccount} companyId={user?.company?.id} />
    </Box>
  );
};

export default NoAccessPage;
